import cn from "clsx";
import React, { HTMLAttributes, ReactNode } from "react";
import { Text } from "../../text/Text";
import styles from "../Table.module.scss";

export type TableProps = React.PropsWithChildren<{
    /**
     * The item to display as the row header
     */
    header?: ReactNode;
}> &
    HTMLAttributes<HTMLTableRowElement>;

export const TableRow: React.FC<TableProps> = ({
    header,
    children,
    className = "",
    ...rowProps
}) => {
    const elements = React.Children.toArray(children);
    const headerItemProps = React.isValidElement(header) ? header.props : {};
    const { children: headerChildren, ...restProps } = headerItemProps;
    return (
        <tr className={cn(styles.row, className)} {...rowProps}>
            {header && (
                <th
                    {...restProps}
                    scope={"row"}
                    data-column={"1"}
                    className={styles.cell}
                >
                    <Text.Body emphasis={"2"} tag="div">
                        {headerChildren}
                    </Text.Body>
                </th>
            )}
            {elements.map((child, index) =>
                React.cloneElement(child as any, {
                    "data-column": `${header ? index + 2 : index + 1}`,
                }),
            )}
        </tr>
    );
};
